import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_MEMBERSHIP_PPMU_OFFSITE_COPY = createFcmDetails('membership_ppmu_offsite_copy', {
	owner: 'Payments',
	context: 'Membership PPMU',
	description: `Copy to use as an override to the default for the PSF promote thank you membership ask modal.
		See also membership_ppmu_offsite_link FCM.
`,
	template: {
		title: 'title value',
		subtitle: 'subtitle value',
		saved_payment_warning_generic: 'saved payment warning stuff',
		yes_btn_title: 'yes button title',
		no_btn_title: 'no button title',
	},
	import: false,
});
